import { Box, Button, Tooltip } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectEditBackgroundView } from 'modules/Editor/store/editorSettingsSelector';
import { setEditBackgroundView } from 'modules/Editor/store/editorSettingsSlice';
import { selectGradientBackground, selectPageBackground } from 'modules/Editor/store/infographSelector';
import { selectActivePage } from 'modules/Editor/store/pageSelector';
import { generateBackgroundString } from 'modules/common/components/Page/Page.helpers';
import { useTranslation } from 'react-i18next';

export const EditBackgroundColor = () => {
  const { t } = useTranslation('editor_toolbar_page_menu', { useSuspense: false });
  const editBackgroundView = useAppSelector(selectEditBackgroundView);
  const activePageId = useAppSelector(selectActivePage);
  const background = useAppSelector(selectPageBackground(activePageId));
  const gradientBackground = useAppSelector(selectGradientBackground(activePageId));
  const dispatch = useAppDispatch();

  const onClick = () => {
    // Just switch tab without close side bar menu if currently editing pattern
    if (editBackgroundView === 'pattern' && editBackgroundView) {
      dispatch(setEditBackgroundView('color'));
      return;
    }

    // Otherwise, toggle side bar menu
    dispatch(setEditBackgroundView(Boolean(editBackgroundView) ? undefined : 'color'));
  };

  return (
    <Tooltip label={t('editBackground.backgroundColor')} hasArrow>
      <Button
        isActive={editBackgroundView === 'color'}
        onClick={onClick}
        size='sm'
        fontWeight='semibold'
        variant='ghost-with-active'
        w={8}
        h={8}
        gap={10}
        p={0.5}
      >
        <Box
          h={5}
          w={5}
          borderRadius={'2px'}
          border={'1px solid'}
          borderColor={'blackAlpha.500'}
          background={generateBackgroundString({ background, gradientBackground })}
        ></Box>
      </Button>
    </Tooltip>
  );
};
